<template>
  <footer class="footer bg-dark text-white py-2 fixed-bottom">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="text-center m-0">
            <small
              >Leicester Caribbean Carnival. {{ new Date().getFullYear() }}.
              All Rights Reserved. Company registration No: 2789061</small
            >
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
